export const ACQUISITION_LIVE_DEMO_EXPERIMENT_KEY = "acquisition_live_demo_v1";

export const ACQUISITION_LIVE_DEMO_VARIANTS = {
  control: "control",
  liveDemo: "live_demo",
} as const;

export type AcquisitionLiveDemoVariant =
  (typeof ACQUISITION_LIVE_DEMO_VARIANTS)[keyof typeof ACQUISITION_LIVE_DEMO_VARIANTS];

const EXPERIMENT_BUCKET_COUNT = 10_000;

function fnv1a(value: string): number {
  let hash = 0x811c9dc5;

  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 0x01000193);
  }

  return hash >>> 0;
}

export function getAcquisitionLiveDemoBucket(seed: string): number {
  if (!seed.trim()) {
    return EXPERIMENT_BUCKET_COUNT - 1;
  }

  return fnv1a(`${ACQUISITION_LIVE_DEMO_EXPERIMENT_KEY}:${seed}`) % EXPERIMENT_BUCKET_COUNT;
}

export function assignAcquisitionLiveDemoVariant({
  seed,
  liveDemoPercent = 50,
}: {
  seed: string;
  liveDemoPercent?: number;
}): AcquisitionLiveDemoVariant {
  if (!seed.trim()) {
    return ACQUISITION_LIVE_DEMO_VARIANTS.control;
  }

  const normalizedPercent = Math.min(100, Math.max(0, liveDemoPercent));
  const liveDemoBucketCount = Math.round(normalizedPercent * 100);

  return getAcquisitionLiveDemoBucket(seed) < liveDemoBucketCount
    ? ACQUISITION_LIVE_DEMO_VARIANTS.liveDemo
    : ACQUISITION_LIVE_DEMO_VARIANTS.control;
}
